import { FaYelp } from "react-icons/fa";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer
      className="bg-[#F5F5F0] border-t border-[#E5E5E0] grain-overlay"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <span className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#CC5500]">
              (Get in Touch)
            </span>
            <a
              href={SITE.phoneHref}
              data-testid="footer-phone"
              className="block mt-6 font-serif-display text-[clamp(2.75rem,8vw,7rem)] leading-[0.9] tracking-tightest text-[#1C1C1A] hover:text-[#CC5500] transition-colors duration-300"
            >
              {SITE.phone}
            </a>
            <a
              href={SITE.emailHref}
              data-testid="footer-email"
              className="block mt-4 font-sans-body text-base text-[#4A4A46] hover:text-[#1C1C1A] transition-colors"
            >
              {SITE.email}
            </a>
            <p className="mt-3 font-sans-body text-sm text-[#4A4A46]">
              Serving the {SITE.location} metro area · 24-hour availability
            </p>
          </div>

          <div className="lg:col-span-5 lg:pt-4 flex flex-col gap-8">
            <div>
              <p className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#4A4A46] mb-4">
                See us on
              </p>
              <div className="flex flex-col gap-3">
                <a
                  href={SITE.yelp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-yelp"
                  className="group inline-flex items-center gap-3 text-[#1C1C1A] hover:text-[#CC5500] transition-colors"
                >
                  <FaYelp size={20} />
                  <span className="font-sans-body text-base border-b border-transparent group-hover:border-[#CC5500] pb-0.5">
                    JSE on Yelp
                  </span>
                </a>
                <a
                  href={SITE.homeAdvisor}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-homeadvisor"
                  className="group inline-flex items-center gap-3 text-[#1C1C1A] hover:text-[#CC5500] transition-colors"
                >
                  <span className="inline-flex items-center justify-center w-5 h-5 bg-[#1C1C1A] text-[#F5F5F0] text-[10px] font-bold group-hover:bg-[#CC5500]">
                    HA
                  </span>
                  <span className="font-sans-body text-base border-b border-transparent group-hover:border-[#CC5500] pb-0.5">
                    JSE on HomeAdvisor
                  </span>
                </a>
              </div>
            </div>

            <div>
              <p className="font-sans-body text-[11px] uppercase tracking-[0.3em] text-[#4A4A46] mb-3">
                Hours
              </p>
              <p className="font-sans-body text-sm text-[#1C1C1A]">
                Mon–Sat · 7:00am – 7:00pm<br />
                24-hour service available on request
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#E5E5E0] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-sans-body text-xs text-[#4A4A46]">
            © {new Date().getFullYear()} JSE Painting Services LLC. Locally owned in Fort Worth, TX.
          </p>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="font-sans-body text-[10px] uppercase tracking-[0.25em] text-[#4A4A46] hover:text-[#CC5500]"
          >
            Crew login
          </a>
        </div>
      </div>
    </footer>
  );
}
